import { render, staticRenderFns } from "./WorkPackageDetails.vue?vue&type=template&id=adf2ccc4&scoped=true"
import script from "./WorkPackageDetails.vue?vue&type=script&lang=js"
export * from "./WorkPackageDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkPackageDetails.vue?vue&type=style&index=0&id=adf2ccc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf2ccc4",
  null
  
)

export default component.exports